<template>
  <div class="tw-p-4">
    <div class="tw-w-full tw-flex tw-flex-wrap tw-justify-between tw-mb-5">
      <GameSearch @onSearchText="search = $event" @search="searchData(null, true)" :showNavLabel="false"></GameSearch>
      <div class="tw-flex tw-items-center tw-space-x-3">
        <v-select
          class="tw-w-48"
          color="#C2C2C2"
          item-color="#C2C2C2"
          v-model="selected_provider"
          :items="provider"
          label="Provider"
          hide-details
          dark
          outlined
          dense
          rounded
        ></v-select>
        <v-select
          class="tw-w-48"
          color="#C2C2C2"
          item-color="#C2C2C2"
          v-model="filtered_item"
          :items="filter"
          label="Game Type"
          hide-details
          dark
          dense
          outlined
          rounded
        ></v-select>
      </div>
    </div>
    <draggable
      v-model="games"
      @change="onChange"
      item-key="uuid"
      handle=".handle"
      v-bind="dragOptions"
      :group="{ name: 'games', pull: 'clone', put: false }"
    >
      <transition-group class="tw-grid tw-grid-cols-1 tw-gap-2" type="transition" :name="!drag ? 'flip-list' : null">
        <div
          v-for="game in games"
          :key="game.uuid"
          class="tw-text-white tw-bg-[#031b41] tw-w-full tw-grid tw-grid-cols-8"
          :class="hasSaved(game) ? 'tw-border-2 tw-shadow tw-border-[#2b57fb] tw-bg-[#2b57fb33]' : ''"
        >
          <div class="tw-flex tw-items-center tw-justify-start tw-ml-2" v-if="!hasSaved(game)">
            <v-btn color="#031b41" dark class="handle">
              <v-icon>mdi-drag</v-icon>
            </v-btn>
          </div>
          <div v-else class="tw-flex tw-items-center tw-justify-start tw-ml-2">
            <v-btn color="#2b57fb" dark>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <div class="tw-flex tw-items-center tw-justify-start">
            <v-img
              :class="`tw-flex tw-items-end ${game.saved ? 'tw-border-4 shadow tw-border-[#2b57fb]' : ''}`"
              :src="game.image"
              height="50"
            ></v-img>
          </div>
          <div class="tw-col-span-2 tw-flex tw-items-center tw-justify-start">{{ game.name }}</div>
          <div class="tw-col-span-2 tw-flex tw-items-center tw-justify-center">
            <div>
              <div>{{ game.main_provider }}</div>
              <div class="tw-text-xs tw-text-gray-400">{{ game.provider }}</div>
            </div>
          </div>
          <div class="tw-flex tw-items-center tw-justify-center">{{ game.type }}</div>
          <div class="tw-flex tw-items-center tw-justify-center tw-text-xs">
            {{ formatTime(game.created_at) }}
          </div>
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import { mapActions } from "vuex";
import GameSearch from "../../../components/GameSearch.vue";
export default {
  name: "GameList",
  components: {
    draggable,
    GameSearch,
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  data() {
    return {
      search: "",
      filter: [],
      provider: [],
      filtered_item: "",
      selected_provider: "",
      curPage: 1,
      itemsPerPage: 20,
      games: [],
      drag: false,
    };
  },

  mounted() {
    this.fetchGames();
  },
  methods: {
    ...mapActions("game", ["getGameDetails"]),
    async fetchGames() {
      try {
        const res = await this.getGameDetails({
          page: this.curPage,
          pageSize: this.itemsPerPage,
        });
        this.games = res.rows;
        console.log(this.games);
      } catch (err) {
        console.log(err);
      }
    },
    onChange() {},
    async getProvider() {
      this.provider.push("All");
      const provider = await this.adminFilterProviders();
      provider.map((obj) => {
        let capitalized = obj.provider.replace(/^./, obj.provider[0].toUpperCase());
        this.provider.push(capitalized);
      });
    },
    formatTime(time) {
      return new Date(time).toLocaleString();
    },
    hasSaved(game) {
      return game.savedGame;
    },
  },
};
</script>
